import { format, isAfter, parse, addYears } from 'date-fns';
import isDate from 'lodash-es/isDate';
import isNaN from 'lodash-es/isNaN';
import replace from 'lodash-es/replace';

const _MS_PER_DAY = 1000 * 60 * 60 * 24;
export const dateDiffInDays = (date1, date2) => {
  const utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
  const utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());

  return Math.floor(Math.abs(utc2 - utc1) / _MS_PER_DAY);
};

const subtractDays = (date, days) => {
  date.setDate(date.getDate() - days);
  return date;
};

export const formatAgoTimeString = (localDateTime) => {
  const now = new Date();
  const targetDate = parse(localDateTime, 'yyyyMMddHHmmss', new Date());

  const betweenTime = Math.floor((now.getTime() - targetDate.getTime()) / 1000 / 60);
  if (betweenTime < 1) return '방금 전';
  if (betweenTime < 60) {
    return `${betweenTime}분 전`;
  }

  const yesterDay = subtractDays(now, 1);
  if (format(yesterDay, 'yyyyMMdd') === format(targetDate, 'yyyyMMdd')) {
    return '어제';
  }

  if (format(yesterDay, 'yyyyMMdd') > format(targetDate, 'yyyyMMdd')) {
    return format(targetDate, 'yyyy-MM-dd');
  }

  const betweenTimeHour = Math.floor(betweenTime / 60);
  if (betweenTimeHour < 24) {
    return `${betweenTimeHour}시간 전`;
  }

  return format(targetDate, 'yyyy-MM-dd');
};

export const yyyyMMddHHmmssToOtherFormat = (value, formatText = 'yyyy-MM-dd') => {
  return format(parse(value, 'yyyyMMddHHmmss', new Date()), formatText);
};

export const yyyyMMddToOtherFormat = (value, formatText = 'yyyy-MM-dd') => {
  return format(parse(value, 'yyyyMMdd', new Date()), formatText);
};

export const formatDateStringToDate = (value, formatText = 'yyyyMMddHHmmss') => {
  return parse(value, formatText, new Date());
};

export const isyyyyMMddFormat = (text) => {
  const date = new Date(replace(text, /(\d{4})(\d{2})(\d{2})/, '$1-$2-$3'));
  return isDate(date) && !isNaN(date.getTime());
};

export const is5YearsGap = (start, end) => {
  return !isAfter(addYears(start, 5), end);
};
